import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propShape, propNumber, propBool, propStr, } from '../../../../../../../helpers/custom-prop-types';
import RfpOneDescriptionPeriod from './RfpOneDescriptionPeriod';
import RfpOneDescriptionPrice from './RfpOneDescriptionPrice';
import RfpOneDescriptionTab from './TabContent/RfpOneDescriptionTab';
const RfpOneDescriptionLeftColumn = (props) => {
    const { averagePeriod, averagePrice, isSingleOffer, mainClass, viewRequest } = props;
    const price = viewRequest.offer.price || 0;
    const period = viewRequest.offer.period || 0;
    return (_jsxs("div", Object.assign({ className: 'right_column' }, { children: [_jsxs("div", Object.assign({ className: 'number_row' }, { children: [_jsx(RfpOneDescriptionPrice, { diff: price - averagePrice, isSingleOffer: isSingleOffer, price: price }), _jsx(RfpOneDescriptionPeriod, { diff: period - averagePeriod, isSingleOffer: isSingleOffer, period: period })] })), _jsx("div", Object.assign({ className: 'tab_row' }, { children: _jsx(RfpOneDescriptionTab, { mainClass: mainClass, viewRequest: viewRequest }, viewRequest.id) }))] })));
};
RfpOneDescriptionLeftColumn.propTypes = {
    averagePeriod: propNumber().isRequired,
    averagePrice: propNumber().isRequired,
    isSingleOffer: propBool().isRequired,
    mainClass: propStr().isRequired,
    viewRequest: propShape().isRequired,
};
export default RfpOneDescriptionLeftColumn;
